module.exports = __webpack_public_path__ + "static/media/category9.d2a67e68.jpg";